<template>
  <div class="main">
    <back title="烘焙甜点全能班"></back>
    <landingBanner
      landingUrl="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking15/banner.jpg"
    ></landingBanner>
    <div class="content">
      <indexTitle title1="免费获取课程学费" title2="To get the tuition"></indexTitle>
      <footerForm color="#fff" bag="#a96b04" words="获取学费"></footerForm>
      <indexTitle title1="课程学习内容" title2="打造国际化与本土化相融合的教学课程体系"></indexTitle>
      <van-swipe :autoplay="3000" indicator-color="#666">
        <van-swipe-item>
            <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking15/part1-1.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
        </van-swipe-item>
        <van-swipe-item>
            <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking15/part1-2.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
        </van-swipe-item>
        <van-swipe-item>
            <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking15/part1-3.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
        </van-swipe-item>
        <van-swipe-item>
            <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking15/part1-4.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
        </van-swipe-item>
      </van-swipe>
      <find></find>
      <indexTitle title1="四大课程优势" title2="绵阳欧米奇独创，铸就热门品牌"></indexTitle>
      <div class="advantage4">
        <div class="advantage4-one">
        
            <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking15/part2-1.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
        </div>
        <div class="advantage4-one">
            <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking15/part2-2.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
        </div>
        <div class="advantage4-one">
             <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking15/part2-3.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
        </div>
        <div class="advantage4-one">
             <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking15/part2-4.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
        </div>
      </div>
    
   
      <indexTitle title1="学员作品" title2="15个月制烘焙甜点全能班学生作品一览"></indexTitle>
      <van-swipe :autoplay="3000" indicator-color="#fff">
        <van-swipe-item>
             <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking15/part4-1.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
        </van-swipe-item>
        <van-swipe-item>
             <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking15/part4-2.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
        </van-swipe-item>
        <van-swipe-item>
             <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking15/part4-3.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
        </van-swipe-item>
        <van-swipe-item>
             <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking15/part4-4.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
        </van-swipe-item>
      </van-swipe>
      <indexTitle title1="师资力量" title2="精英名师亲授，助力你的成功事业路！"></indexTitle>
      <van-swipe :autoplay="3000" indicator-color="#000">
        <van-swipe-item>
             <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking15/part5-1.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
        </van-swipe-item>
        <van-swipe-item>
             <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking15/part5-2.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
        </van-swipe-item>
      </van-swipe>
      <indexTitle title1="欧式教学环境" title2="简欧式的建筑风格，环境超赞！"></indexTitle>
      <van-swipe :autoplay="3000" indicator-color="#fff">
        <van-swipe-item>
             <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking15/part6-1.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
        </van-swipe-item>
        <van-swipe-item>
             <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking15/part6-2.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
        </van-swipe-item>
        <van-swipe-item>
             <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking15/part6-3.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
        </van-swipe-item>
        <van-swipe-item>
             <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking15/part6-4.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
        </van-swipe-item>
      </van-swipe>
      <find></find>
      <indexTitle title1="创就业帮扶" title2="全国院校联动，全方位创就业扶持"></indexTitle>
      <tab2></tab2>
      <indexTitle title1="优秀创就业学员" title2="迷茫的年纪，成功的选择"></indexTitle>
      <van-swipe :autoplay="3000" indicator-color="#fff">
        <van-swipe-item>
             <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking15/part7-1.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
        </van-swipe-item>
        <van-swipe-item>
             <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking15/part7-2.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
        </van-swipe-item>
        <van-swipe-item>
             <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking15/part7-3.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
        </van-swipe-item>
        <van-swipe-item>
             <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking15/part7-4.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
        </van-swipe-item>
      </van-swipe>
      <div style="width:100%;height:20px;"></div>
      <indexTitle title1="学员评价" title2="我们所有的努力只为了得到你们的认可"></indexTitle>
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/dessert/talk.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
      <indexTitle title1="推荐就业" title2="校企合作，定向委托"></indexTitle>
         <van-image
          src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/v2/img/baking15/logos.jpg"
        >
          <template v-slot:loading>
            <van-loading size="20" color="#fff" />
          </template>
        </van-image>
      <indexTitle title1="选择课程，了解学费" title2="Choose a course to learn about tuition"></indexTitle>
      <footerForm color="#fff" bag="#a96b04" words="点击获取学费报价"></footerForm>
    </div>
    <div class="h25px" style="width:100%;height:25px;"></div>
    <foot></foot>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  components: {
    back: () => import("../../../components/head/back"),
    landingBanner: () => import("../../../components/common/landing-banner"),
    foot: () => import("@/components/foot/foot"),
    indexTitle: () => import("@/components/common/indexTitle"),
    find: () => import("@/components/common/find"),
    tab2: () => import("@/components/common/tab2"),
    footerForm: () => import("@/components/form/footerForm"),
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
/deep/ .van-swipe__indicators{
  bottom: 15px;
    left: 10%;
}
.main {
  margin-top: 50px;
}
.content {
  padding: 10px;
}
.advantage4 {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.advantage4-one {
  width: 49.5%;
}
</style>